import React, { FunctionComponent } from 'react'

export interface Props {
  phone: string
}

const HandleInsufficientFunds: FunctionComponent<Props> = ({ phone }) => {
  return (
    <div className="task-bodies__col2">
      <div className="task-bodies__info-header">
        <div className="task-bodies__info-header__row">Phone #</div>
      </div>
      <div className="task-bodies__info-block">
        <div className="task-bodies__info-block__row">{phone}</div>
      </div>
    </div>
  )
}

export default HandleInsufficientFunds
